import type { Signal } from "@suse-o11y/signal";
import React from "react";

import { DropdownWithHostContextProvider } from "./_dropdown-with-host-context";

export const DropdownWithHostProvider: React.FC<
	React.PropsWithChildren<{
		isOpen: Signal<boolean>;
	}>
> = ({ isOpen, ...props }) => <DropdownWithHostContextProvider value={isOpen} {...props} />;
